import { useEffect, useCallback } from 'react';
export function useScrollAware(onScroll, scrollNode) {
    var calculateProps = useCallback(function () { return ({
        scrollTop: scrollNode ? scrollNode.scrollTop : window.scrollY,
        scrollHeight: (scrollNode || window.document.body).scrollHeight,
        bodyWidth: (scrollNode || window.document.body).clientWidth,
    }); }, [scrollNode]);
    useEffect(function () {
        if (window) {
            var handleScroll_1 = function () { return onScroll(calculateProps()); };
            if (scrollNode) {
                scrollNode.addEventListener('scroll', handleScroll_1);
                return function () { return scrollNode.removeEventListener('scroll', handleScroll_1); };
            }
            else {
                window.addEventListener('scroll', handleScroll_1);
                return function () { return window.removeEventListener('scroll', handleScroll_1); };
            }
        }
    }, [calculateProps, onScroll, scrollNode]);
}
//# sourceMappingURL=useScrollAware.js.map